import { Items, Length, RecordCreate, RecordMerge } from "@pdfking/tfunc"

import { DecodeState, EncodeState } from "#public"

import type { RouteCodec } from "../types/RouteCodec"

// The default codec: everything that differs from the defaults, encoded into
// the single `:data` param — so the url stays short and the backend's
// `urlstate` builds the same links.
export const DataCodec: RouteCodec<Record<string, unknown>, "/:data?"> = {
  encode: (props, defaults) => {
    const changed = RecordCreate(Items(props).filter(([key, value]) => value !== defaults[key]))
    return Length(changed) > 0 ? { data: EncodeState(changed) } : {}
  },
  decode: (params, defaults) =>
    RecordMerge(defaults, params.data ? DecodeState<Record<string, unknown>>(params.data) : {}),
}
